import { useEffect, useState } from 'react';
import { Header as LibraryHeader } from '@celltrak/ui-components';

import { getUserInfo } from '../../services';

import useHeaderMenu from './hooks';

function Header() {
  const [userName, setUserName] = useState('');
  const { logoutHandler } = useHeaderMenu();

  useEffect(() => {
    const getUserFirstName = async () => {
      const firstName = await getUserInfo();

      setUserName(firstName);
    };

    getUserFirstName();
  }, []);

  return <LibraryHeader logo="evv" firstName={userName} onLogoutClick={() => logoutHandler()} />;
}

export default Header;
